import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { LOAN_SECTION_KEYS } from "../loan.constants";

import { rows } from "./section-loan-misc-rows";

const nullData = {
  stylename: "Work Sans /  16 Regular",
  fontFamily: "Work Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "center",
  textColor: "#7d8084"
};

export class LoanMisc extends Component {
  drawDataMisc(data) {
    if (data.details.loanProvider > 0 ||
      data.details.servicerCompanyId ||
      data.details.loanReferenceNumber ||
      data.details.counterparty ||
      data.details.loanSeniorityId ||
      data.details.loanStatusId ||
      data.details.loanTypeId ||
      data.details.paymentDay ||
      data.details.daycountId ||
      data.details.businessDayAdjustmentId ||
      data.details.conversionOption ||
      data.details.defaultInterestSpread ||
      data.details.recurringCosts ||
      data.details.additionalInterest ||
      data.details.collateralization ||
      data.details.lenderCompany) {
      return <AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={data} />;
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  render() {
    const { data, history, loanId, enableEditButton, eventHandlers, ...other } = this.props;
    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Miscellaneous",
            key: LOAN_SECTION_KEYS.MISCELLANEOUS,
            isTitleGroup: true,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.MISCELLANEOUS}`),
            sections: [
              this.drawDataMisc(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.miscellaneous.header",
            referenceStyles: { marginLeft: "20px" }
          }
        ]}
      />
    );
  }
}
